"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonChildren = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconWrapper = require("./IconWrapper.js");
var ButtonChildren = exports.ButtonChildren = function ButtonChildren(_ref) {
  var iconOnly = _ref.iconOnly,
    iconLeading = _ref.iconLeading,
    iconTrailing = _ref.iconTrailing,
    children = _ref.children,
    buttonSize = _ref.buttonSize;
  var renderIcon = function renderIcon(position, icon) {
    return icon && /*#__PURE__*/_react["default"].createElement(_IconWrapper.IconWrapper, {
      icon: icon,
      position: position,
      buttonSize: buttonSize
    });
  };
  return iconOnly ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderIcon('only', iconOnly)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderIcon('leading', iconLeading), children, renderIcon('trailing', iconTrailing));
};